export default __webpack_public_path__ + "static/media/hub.e5a05cc5.png";